(function () {
  if (window.__ahVariantSwatchSwap) return;
  window.__ahVariantSwatchSwap = true;

  var style = document.createElement('style');
  style.textContent = [
    '.card--product a.swatch{cursor:pointer;flex:0 0 auto;}',
    '.card--product a.swatch[aria-current="true"] .color{outline:1.5px solid currentColor;outline-offset:2px;}',
    '.swatches .swatch-more{font-size:12px;letter-spacing:0.04em;opacity:0.65;white-space:nowrap;text-decoration:none;line-height:1;align-self:center;flex:0 0 auto;}',
    '.card--product .card-body h3{min-height:0!important;max-height:2.6em!important;overflow:hidden!important;margin-bottom:2px!important;}',
    '.card--product .card-body h3 a{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}',
    '.card--product .card-body .swatches{margin-top:6px!important;}',
    '.card--product .quick-view-or-add{background:transparent!important;}',
    '.card--product .quick-view-or-add .btn,.card--product .quick-view-link,.card--product .quick-add-link{background:transparent!important;border:0!important;box-shadow:none!important;color:#fff!important;text-shadow:0 1px 4px rgba(0,0,0,0.6),0 0 3px rgba(0,0,0,0.45)!important;padding:16px 10px 12px!important;min-height:0!important;height:auto!important;letter-spacing:0.09em;font-weight:500;}',
    '.card--product .quick-view-or-add .label{font-size:12px;}',
    '.card--product .quick-view-link svg,.card--product .quick-add-link svg{display:none!important;}'
  ].join('');
  document.head.appendChild(style);

  function setImg(img, url) {
    if (!img || !url) return;
    img.setAttribute('src', url);
    img.setAttribute('srcset', url);
    img.removeAttribute('sizes');
  }

  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('a.swatch[data-swatch-swap]') : null;
    if (!sw) return;
    var card = sw.closest('.card--product');
    if (!card) return;
    e.preventDefault();
    var product = sw.getAttribute('data-variant-image');
    var swatchImg = sw.getAttribute('data-swatch-image');
    var hover = sw.getAttribute('data-variant-hover');
    var imgs = card.querySelectorAll('.card-media img');
    var mainUrl = product || swatchImg;
    if (mainUrl && imgs.length) {
      setImg(imgs[0], mainUrl);
      if (imgs.length > 1) { setImg(imgs[1], hover || mainUrl); }
    }
    var swatches = card.querySelectorAll('a.swatch');
    for (var i = 0; i < swatches.length; i++) { swatches[i].removeAttribute('aria-current'); }
    sw.setAttribute('aria-current', 'true');
    var href = sw.getAttribute('href');
    if (href) {
      var links = card.querySelectorAll('a.card-media-link, .card-body h3 a');
      for (var j = 0; j < links.length; j++) { links[j].setAttribute('href', href); }
      var qv = card.querySelector('quick-view');
      if (qv) {
        qv.setAttribute('data-url', href);
        var vid = sw.getAttribute('data-variant-id');
        if (vid) qv.setAttribute('data-variant', vid);
      }
    }
  }, false);

  function ensureMore(container) {
    var more = container.querySelector('.swatch-more');
    if (!more) {
      more = document.createElement('a');
      more.className = 'swatch-more';
      more.setAttribute('href', container.getAttribute('data-product-url') || '#');
      more.setAttribute('aria-label', 'More colors');
      container.appendChild(more);
    }
    return more;
  }

  var MAX_DOTS = 5;

  function fitRow(container) {
    var dots = Array.prototype.slice.call(container.querySelectorAll('a.swatch'));
    if (!dots.length) return;
    var more = ensureMore(container);
    var cw = container.clientWidth;
    if (!cw) return;
    var rightEdge = container.getBoundingClientRect().left + cw;
    var total = dots.length;

    function apply(count) {
      for (var i = 0; i < total; i++) { dots[i].style.display = i < count ? '' : 'none'; }
      if (count < total) { more.textContent = '+' + (total - count); more.style.display = ''; }
      else { more.style.display = 'none'; }
    }

    var n = Math.min(MAX_DOTS, total);
    apply(n);

    var guard = 0;
    while (n > 1 && guard < 40) {
      var lastVisible = (n < total) ? more : dots[n - 1];
      if (lastVisible.getBoundingClientRect().right <= rightEdge - 1) break;
      n--;
      apply(n);
      guard++;
    }
  }

  function fitAll() {
    var rows = document.querySelectorAll('[data-swatch-row]');
    for (var i = 0; i < rows.length; i++) { fitRow(rows[i]); }
  }

  // Quick-view drawer: when the chosen stone has no product photo, show its swatch image.
  function swatchUrlFromColor(colorEl) {
    if (!colorEl) return '';
    var bg = getComputedStyle(colorEl).backgroundImage || '';
    var a = bg.indexOf('url(');
    if (a < 0) return '';
    var b = bg.lastIndexOf(')');
    var url = bg.slice(a + 4, b).replace(/['"]/g, '').trim();
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url;
  }

  function quickViewFallback() {
    var drawer = document.querySelector('.drawer--quick-buy');
    if (!drawer) return;
    var vsScript = drawer.querySelector('variant-selects script[type="application/json"]');
    if (!vsScript) return;
    var v;
    try { v = JSON.parse(vsScript.textContent); } catch (e) { return; }
    if (!v || v.featured_image) return;
    var checked = drawer.querySelector('.quick-view-radios input:checked');
    if (!checked) return;
    var lbl = checked.closest('label') || (checked.id && document.querySelector('label[for="' + checked.id + '"]'));
    if (!lbl) return;
    var url = swatchUrlFromColor(lbl.querySelector('.color'));
    if (!url) return;
    var img = drawer.querySelector('img.media, picture.media img, .media--picture img');
    if (!img) return;
    if (img.getAttribute('src') !== url) { setImg(img, url); }
  }

  var t, tq;
  function scheduleFit() { clearTimeout(t); t = setTimeout(fitAll, 150); }
  function scheduleQV() { clearTimeout(tq); tq = setTimeout(quickViewFallback, 250); }

  if (document.readyState !== 'loading') { fitAll(); }
  else { document.addEventListener('DOMContentLoaded', fitAll); }
  window.addEventListener('load', fitAll);
  window.addEventListener('resize', scheduleFit, { passive: true });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quick-view-radios')) { scheduleQV(); }
  }, false);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      var fit = false;
      for (var i = 0; i < muts.length; i++) {
        var an = muts[i].addedNodes;
        for (var j = 0; j < an.length; j++) {
          var node = an[j];
          if (node.nodeType === 1 && ((node.matches && node.matches('[data-swatch-row]')) || (node.querySelector && node.querySelector('[data-swatch-row]')))) { fit = true; }
        }
      }
      if (fit) scheduleFit();
      if (document.querySelector('.drawer--quick-buy')) scheduleQV();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
